export enum SearchSelector {
  Name = 'name',
  Email = 'email',
  EntityUId = 'entityUid',
  EntityId = 'entityId',
  Status = 'status',
}
